<button
  type="button"
  (click)="onClick()"
  class="relative flex items-center gap-3 bg-neutral-gray-800 hover:bg-cantera-gray-hover transition-colors rounded-lg p-3 w-full"
>
  <!-- Pill "Nuevo" si es necesario -->
  <ds-pill-soon 
    *ngIf="data().showPill"
    [textValue]="data().pillText || 'Nuevo'"
    [animationValue]="'swing'"
    [backgroundColorValue]="'bg-cantera-red-stepper'"
    [textColorValue]="'text-white'"
    [sizeValue]="'medium'"
    class="absolute -top-2 -left-2 z-10"
  ></ds-pill-soon>

  <!-- Icono -->
  <img 
    [src]="data().iconSrc" 
    [alt]="data().title" 
    class="w-10 h-10 flex-shrink-0" 
  />

  <!-- Título -->
  <span 
    class="flex-1 text-white text-[16px] font-poppins font-semibold text-left"
  >
    {{ data().title }}
  </span>

  <!-- Flecha derecha gris -->
  <app-svg-icon 
    [iconName]="SvgIcon.CHEVRON_RIGHT_GRAY" 
    [size]="24" 
    class="flex-shrink-0 text-neutral-gray-600"
  ></app-svg-icon>
</button>